import queryFn from "ApiLayer/Reports/Recommendations/queryCumulativeCarbonEmissionsCard";
import { useAccessToken } from "hooks/useAccessToken";
import { useQuery } from "react-query";
import { QUERY_STALE_TIME } from "utils/constants";

export const useCumulativeCarbonEmissionsCard = (filtersetUid: string) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["recommendationsCumulativeCarbonEmissionsCard", filtersetUid],
        queryFn: async () => queryFn(accessToken, { reportFiltersetUid: filtersetUid }),
        staleTime: QUERY_STALE_TIME,
    });
};
